module.exports = __webpack_public_path__ + "img/13.d8d7c0e5.jpeg";